import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'src/app/components/toast/toaster.service';
import { ApiErrorMessage } from 'src/app/enums/api-status.enum';
import { HomeService } from 'src/app/services/home/home.service';
import { IHiringChartData, IHiringData } from './hiring-attrition.interface';

@Component({
  selector: 'app-hiring-attrition',
  templateUrl: './hiring-attrition.component.html',
  styleUrls: ['./hiring-attrition.component.scss'],
})
export class HiringAttritionComponent implements OnInit {
  public hiringAttrition!: IHiringChartData[];
  loading: boolean = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute,
    private toasterServiceRef: ToasterService,
  ) {}
  columns = ['group', 'field1', 'field2', 'field3'];
  colors = ['#377dc7', 'url(#white-bar-pattern)', '#5bb362'];
  legends = ['Hiring Past', 'Hiring Projection', 'Attrition'];

  getDate(date: string) {
    let datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'MMM d, y');
  }

  ngOnInit(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.homeServiceRef.getHiringAttrition(id).subscribe({
        next: (res) => {
          this.hiringAttrition = res.hiringAndAttrition.map(
            (data: IHiringData, index: number) => {
              return {
                group: data.occurenceQuarter,
                field1: data.hiringPastCount,
                field2: data.hiringProjectionCount,
                field3: data.attritionCount,
              };
            }
          );
          this.loading = false;
        },
        error: (err) => {
          this.toasterServiceRef.error(ApiErrorMessage.DEFAULT);
          this.loading = false;
        },
      });
    }
  }
}
